/* Stealth slide-out cart and the browser half of the upsell brain (round 2, item 9).
   Spec: Strategy/2026-10/cart-drawer/Strategy-and-Design-2026-10-03.md. Rules: snippets/sp-upsell-rules.liquid.

   Vanilla, deferred, no jQuery. Every change goes through Shopify's Ajax cart with Section Rendering, so one request
   returns the new drawer HTML, Liquid stays the single source of truth, and Shopify's own pixels keep firing.
   The server decides which add-on cards exist (snippets/sp-upsell-brain.liquid); this file applies:
     the saved bike   A1 sell / ask / never (SP.Garage bike.model), A4 bracket variant for the bike's generation
     the session      sp_cd_skip (rules said No thanks to), sp_cd_hdr (slip-on lines confirmed on a Stealth header),
                      sp_cd_src (cart_upsell_src entries written), reset when the cart empties or the cart cookie changes
   Wholesale Gorilla reprices this markup by DOM index (.cart__price per line, div[data-subtotal], .cart__checkout):
   lines are never moved, and nothing here binds a handler that stops Check out.
   Public: window.SP.CartDrawer.open(), .close(), .refresh({ open: true }). */
(function () {
  'use strict';

  var root = document.querySelector('[data-sp-cd]');
  if (!root) return;
  var SURFACE = root.getAttribute('data-surface') || 'drawer';
  var IS_DRAWER = SURFACE === 'drawer';
  var SECTION = root.getAttribute('data-section') || 'sp-cart-drawer';
  var SECTIONS_URL = IS_DRAWER ? '/' : '/cart';
  var panel = root.querySelector('[data-cd-panel]');
  var isOpen = false;
  var lastTrigger = null;
  var selfUntil = 0;
  var lastEventAt = 0;
  var lastRead = Date.now();
  var stale = false;
  var seenPromo = {};
  var SP = (window.SP = window.SP || {});

  /* ---------------------------------------------------------------- helpers */
  function qs(sel, el) { return (el || root).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(tpl, t) { return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return t && t[k] != null ? t[k] : ''; }); }
  function money(cents, trim) {
    if (SP.money) return SP.money(cents, trim);
    var v = (Math.round(cents) / 100).toFixed(2);
    return '$' + (trim && /\.00$/.test(v) ? v.slice(0, -3) : v).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); }
  function ssList(key) { try { return (sessionStorage.getItem(key) || '').split('|').filter(Boolean); } catch (e) { return []; } }
  function ssAdd(key, val) { if (!val) return; try { var l = ssList(key); if (l.indexOf(val) < 0) l.push(val); sessionStorage.setItem(key, l.join('|')); } catch (e) { /* private mode */ } }
  function ssDel(key, val) { try { sessionStorage.setItem(key, ssList(key).filter(function (x) { return x !== val; }).join('|')); } catch (e) { /* ignore */ } }
  function ssClear() { try { ['sp_cd_skip', 'sp_cd_hdr', 'sp_cd_src', 'sp_cd_gift_off'].forEach(function (k) { sessionStorage.removeItem(k); }); } catch (e) { /* ignore */ } }
  function cookie(name) { var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function content() { return qs('[data-cd-content]'); }
  function isDealer() { var c = content(); return (c && c.getAttribute('data-dealer') === 'true') || !!window.isWsgCustomer; }
  function garage() { return SP.Garage && typeof SP.Garage.active === 'function' ? SP.Garage : null; }
  function klaviyo(name, props) {
    try { var k = window.klaviyo || window._learnq; if (k && typeof k.push === 'function') k.push(['track', name, props]); } catch (e) { /* ignore */ }
  }
  /* Shopify custom events (plan 4.3); a Custom Pixel subscribed to the name forwards them */
  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data || {}); } catch (e) { /* ignore */ }
  }
  function announce(text) {
    var live = qs('[data-cd-live]');
    if (!live || !text) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }
  function cartJson() {
    var s = qs('[data-cd-cart]');
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  function subtotal() { var c = content(); return c ? parseInt(c.getAttribute('data-total') || '0', 10) || 0 : 0; }

  /* ---------------------------------------------------------------- network */
  var bc = null;
  try { bc = 'BroadcastChannel' in window ? new BroadcastChannel('sp-cart') : null; } catch (e) { bc = null; }
  function told() { try { if (bc) bc.postMessage({ at: Date.now() }); else localStorage.setItem('sp_cart_ping', String(Date.now())); } catch (e) { /* ignore */ } }

  function post(url, body, withSections) {
    if (withSections !== false) { body.sections = SECTION; body.sections_url = SECTIONS_URL; }
    selfUntil = Date.now() + 8000;
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).catch(function () {
      /* CR-11: a network failure (offline) says so in plain words, never the browser's "Failed to fetch" */
      throw new Error('We could not reach the store. Check your connection and try again.');
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || (j && j.status && j.status >= 400)) {
          var err = new Error((j && (j.description || j.message)) || 'That did not go through. Try again.');
          err.status = r.status;
          throw err;
        }
        told();
        return j;
      });
    });
  }

  var refreshing = null, again = null;
  function refresh(opts) {
    if (refreshing) { again = opts || {}; return refreshing; }
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
    selfUntil = Date.now() + 3000;
    /* No Accept: application/json here: on /cart that header returns the cart JSON instead of the section (Big Gun QA 7). */
    refreshing = fetch(SECTIONS_URL + '?sections=' + encodeURIComponent(SECTION) + '&_sp=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j) render(j[SECTION], Object.assign({}, opts, { fromRefresh: true })); })
      .catch(function () { /* keep what is on screen */ })
      .then(function () {
        clearTimeout(timer);
        refreshing = null;
        if (again) { var o = again; again = null; return refresh(o); }
      });
    return refreshing;
  }

  /* ---------------------------------------------------------------- render */
  function snapshot() {
    var m = {};
    qsa('[data-cd-line]').forEach(function (l) { m[l.getAttribute('data-key')] = parseInt(l.getAttribute('data-qty') || '0', 10); });
    return m;
  }
  function render(html, opts) {
    opts = opts || {};
    if (!html) { if (!opts.fromRefresh) refresh(Object.assign({}, opts, { fromRefresh: true })); return; }
    lastRead = Date.now();
    stale = false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cd-content]');
    var cur = content();
    if (!fresh || !cur) return;
    var body = qs('[data-cd-body]');
    var scroll = body ? body.scrollTop : 0;
    var act = document.activeElement;
    var actInRoot = !!(act && root.contains(act));
    var focusSel = null;
    var focusKey = null, nextKey = null;
    if (act && root.contains(act)) {
      var fl = act.closest('[data-cd-line]');
      if (fl) {
        focusKey = fl.getAttribute('data-key');
        var nx = fl.nextElementSibling || fl.previousElementSibling;
        nextKey = nx && nx.matches('[data-cd-line]') ? nx.getAttribute('data-key') : null;
      }
      ['data-cd-step', 'data-cd-qty', 'data-cd-remove', 'data-cd-note-toggle', 'data-cd-checkout'].some(function (a) {
        if (!act.hasAttribute(a)) return false;
        focusSel = (fl ? '[data-key="' + fl.getAttribute('data-key') + '"] ' : '') + '[' + a + (a === 'data-cd-step' ? '="' + act.getAttribute(a) + '"' : '') + ']';
        return true;
      });
    }
    /* CR-03: an action that knows where focus belongs next (card add, cart swap) says so */
    if (opts.focus) focusSel = opts.focus;
    else if (window.SP && SP.cdFocus) { focusSel = SP.cdFocus; act = act || document.body; }
    if (window.SP) SP.cdFocus = null;
    var noteOpen = qs('[data-cd-note-toggle]') && qs('[data-cd-note-toggle]').getAttribute('aria-expanded') === 'true';
    cur.replaceWith(document.importNode(fresh, true));
    if (noteOpen) toggleNote(true);
    var count = parseInt(fresh.getAttribute('data-count') || '0', 10) || 0;
    var cEl = qs('[data-cd-count]');
    if (cEl) { cEl.textContent = count + (count === 1 ? ' item' : ' items'); cEl.hidden = count === 0; }
    qsa('.cart-link__bubble', document).forEach(function (b) { b.classList.toggle('cart-link__bubble--visible', count > 0); });
    qsa('.cart-link__bubble-num', document).forEach(function (b) { b.textContent = count; });
    qsa('[data-sp-cart-label]', document).forEach(function (b) { b.textContent = (b.getAttribute('data-title') || 'Cart') + ', ' + (count === 0 ? 'empty' : count === 1 ? '1 item' : count + ' items'); });
    enhance(opts);
    var nb = qs('[data-cd-body]');
    if (nb) nb.scrollTop = opts.top ? 0 : scroll;
    if (focusSel) {
      var f = qs(focusSel);
      if (f && !f.disabled) f.focus();
      else {
        /* CR-03 / CR-12: a disabled target (minus at 1) goes to the same line's quantity; a removed line to the next
           line's name, else Check out, else Close */
        var sameLine = focusKey ? qs('[data-key="' + focusKey + '"]') : null;
        var g2 = sameLine ? qs('[data-cd-qty]', sameLine) : (nextKey ? qs('[data-key="' + nextKey + '"] .sp-cd__name') : null) || qs('[data-cd-checkout]');
        if (g2) g2.focus(); else focusFirst();
      }
    }
    else if (actInRoot && !root.contains(document.activeElement)) {
      /* the focused element was replaced: keep the rider on the same line (its name) rather than Close (CR-03) */
      var sl = focusKey ? qs('[data-key="' + focusKey + '"] .sp-cd__name') : null;
      if (sl) sl.focus(); else focusFirst();
    }
    /* D15: a re-render while Undo is open (a background refresh) keeps the row, its time left and its focus */
    /* R2-B1: a status message ("X added", "X is back") replaces the Undo row for good; never bring a stale Undo back */
    if (opts.status) undoActive = null;
    if (undoActive && !undoActive.st.isConnected) {
      var ua = undoActive, uaFocus = act && act.matches && act.matches('[data-cd-undo]');
      offerUndo(ua.item, ua.name, ua.remaining());
      if (uaFocus) { var nu = qs('[data-cd-undo]'); if (nu) nu.focus(); }
    }
    if (opts.status) { var st = qs('[data-cd-status]'); if (st) { st.textContent = opts.status; st.hidden = false; } }
    var cart = cartJson();
    emit('sp:cart:change', { count: count, total: subtotal(), cart: cart });
    /* The cart swap safety net (stealth-garage.js renderCartKits) draws from this instead of reading /cart.js. */
    if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  /* After every render and on load: new-line marks, saved bike, header question, cards, empty state, offline, wallets. */
  function enhance(opts) {
    opts = opts || {};
    var c = content();
    var token = cookie('cart');
    try {
      if (sessionStorage.getItem('sp_cd_token') !== token) { ssClear(); sessionStorage.setItem('sp_cd_token', token); }
    } catch (e) { /* ignore */ }
    if (c && c.getAttribute('data-count') === '0') {
      ssClear();
      /* An emptied cart keeps its attributes: clear the upsell trail so it never reaches the next order. */
      if (c.getAttribute('data-upsell-src')) post('/cart/update.js', { attributes: { cart_upsell_src: '' } }, false).catch(function () {});
    }
    markNew(opts.before);
    fitLines();
    headerQuestion();
    cards();
    emptyBtn();
    applyOffline();
    reconcileGift();
    if (IS_DRAWER) {
      /* Sections never carry a scroll position for a new add: show the top. */
      if (opts.top) { var b = qs('[data-cd-body]'); if (b) b.scrollTop = 0; }
    }
    try {
      if (window.Shopify && Shopify.StorefrontExpressButtons && typeof Shopify.StorefrontExpressButtons.initialize === 'function') Shopify.StorefrontExpressButtons.initialize();
    } catch (e) { /* wallets stay as rendered */ }
  }

  function markNew(before) {
    if (!before) return;
    var news = qsa('[data-cd-line]').filter(function (l) {
      var k = l.getAttribute('data-key');
      return !(k in before) || parseInt(l.getAttribute('data-qty') || '0', 10) > before[k];
    });
    news.forEach(function (l) {
      l.classList.add('is-new');
      var a = qs('[data-cd-added]', l); if (a) a.hidden = false;
      /* The tint fades out; the "Added" mark stays until the next change. */
      setTimeout(function () { l.classList.add('is-faded'); }, 60);
    });
    if (news.length) announce(fill('{title} added. Subtotal {subtotal}.', { title: news[0].getAttribute('data-name'), subtotal: money(subtotal()) }));
  }

  /* ---------------------------------------------------------------- saved bike on the lines */
  var ICON_OK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 12.5 9.5 18 20 6"/></svg>';
  var ICON_WARN = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3 2 20h20L12 3z"/><path d="M12 10v4M12 17v.5"/></svg>';
  function fitLine(p, kind, html) {
    p.className = 'sp-cd__fit ' + (kind === 'ok' ? 'is-ok' : 'is-warn');
    p.innerHTML = (kind === 'ok' ? ICON_OK : ICON_WARN) + '<span>' + html + '</span>';
    p.hidden = false;
  }
  function fitLines() {
    var g = garage();
    var bike = g ? g.active() : null;
    qsa('[data-cd-line]').forEach(function (l) {
      var p = qs('[data-cd-fit]', l);
      if (!p) return;
      p.hidden = true;
      if (l.classList.contains('is-hdr-ok')) { fitLine(p, 'ok', 'Bolts to your Stealth header. <button type="button" data-cd-hdr-undo>Undo</button>'); return; }
      if (!g || !bike || typeof g.fits !== 'function') return;
      var handle = l.getAttribute('data-handle');
      var label = esc(g.label(bike));
      var change = ' <button type="button" data-sp-garage-open>Change bike</button>';
      /* A1: the bracket fits the Low Rider ST only (coordinator ruling 2026-10-03). */
      if (handle === 'low-rider-st-baggage-support-bracket') {
        if (bike.genId === 'softail-m8' && bike.model === 'low-rider-st') fitLine(p, 'ok', 'Fits your ' + label + '.' + change);
        else if (bike.genId === 'softail-m8' && bike.model) fitLine(p, 'warn', 'This bracket is for the Low Rider ST. Your ' + label + ' does not need it.' + change);
        return;
      }
      var r;
      try { r = g.fits(handle, l.getAttribute('data-ptype') || '', l.getAttribute('data-has-model') === 'true'); } catch (e) { return; }
      if (!r) return;
      if (r.status === 'fits') {
        fitLine(p, 'ok', 'Fits your ' + esc(g.label(r.bike)) + '.' + (r.other ? '' : change));
      } else if (r.status === 'no_fit') {
        var own = r.owners && r.owners[0] ? esc(r.owners[0].label) : 'another bike';
        var url = typeof g.shopUrl === 'function' ? g.shopUrl(bike) : '';
        fitLine(p, 'warn', 'Built for the ' + own + ', not your ' + label + '.' + (url ? ' <a href="' + esc(url) + '">See what fits your ' + label + '</a>.' : '') + change);
      } else if (r.status === 'universal' && r.slipon && r.headerless && !qs('[data-cd-kit]', l)) {
        var hurl = typeof g.shopUrl === 'function' ? g.shopUrl(r.headerless) : '';
        var hl = esc(g.label(r.headerless));
        fitLine(p, 'warn', 'Your ' + hl + ' has no Stealth header, and this muffler does not bolt to stock pipes.' + (hurl ? ' <a href="' + esc(hurl) + '">See what fits your ' + hl + '</a>.' : '') + change);
      }
    });
  }

  /* The cart swap safety net (A5) mounts on an orphan universal slip-on; the rider answers it before any card shows. */
  /* The answer is one field on the saved bike when sp2-knownfit's SP.Garage.setHeaders exists (shared with the PDP),
     else a per-line session answer. A headerless bike gets no question: its note already says what fits. */
  function bikeHeaders() { var g = garage(), b = g ? g.active() : null; return b && b.headers ? b.headers : ''; }
  function headerless(line) {
    var g = garage(); if (!g || !g.active() || typeof g.fits !== 'function' || !line) return false;
    try { var r = g.fits(line.getAttribute('data-handle'), line.getAttribute('data-ptype') || '', false); return !!(r && r.status === 'universal' && r.headerless); } catch (e) { return false; }
  }
  function headerQuestion() {
    var ok = ssList('sp_cd_hdr');
    var stealth = bikeHeaders() === 'stealth';
    qsa('[data-cd-kit]').forEach(function (k) {
      var line = k.closest('[data-cd-line]');
      var key = line ? line.getAttribute('data-key') : '';
      var answered = stealth || ok.indexOf(key) > -1;
      if (line) line.classList.toggle('is-hdr-ok', answered);
      var mount = qs('[data-sp-cart-kit]', k);
      var q = qs('[data-cd-hdr]', k);
      var noQ = headerless(line);
      var sync = function () { if (q) q.hidden = noQ || line.classList.contains('is-hdr-ok') || !mount || mount.hidden || !mount.innerHTML.trim() || !!mount.querySelector('[data-cd-hdr-ok]'); }; /* CR-06: the card carries the answer itself */
      sync();
      if (mount && !mount.__spObs && 'MutationObserver' in window) {
        mount.__spObs = true;
        new MutationObserver(sync).observe(mount, { childList: true, attributes: true, attributeFilter: ['hidden'] });
      }
    });
    fitLines();
  }

  /* ---------------------------------------------------------------- cards (browser half of the brain) */
  var current = null;
  function cardMode(card, mode) {
    qsa('[data-up-mode]', card).forEach(function (m) { m.hidden = m.getAttribute('data-up-mode') !== mode; });
    var h = qs('[data-up-mode="' + mode + '"] .sp-up__h', card);
    if (h) card.setAttribute('aria-labelledby', h.id);
    var add = qs('[data-up-add]', card);
    if (add) add.textContent = add.getAttribute(mode === 'ask' ? 'data-l-ask' : 'data-l-sell') || add.textContent;
    var no = qs('[data-up-ask-no]', card);
    if (no) no.hidden = mode !== 'ask';
    card.__mode = mode;
  }
  function applyBike(card, g, bike) {
    var map = {};
    try { map = JSON.parse(card.getAttribute('data-up-bikes') || '{}'); } catch (e) { map = {}; }
    var hit = bike && map[bike.genId];
    var choose = qs('[data-up-choose]', card);
    var h = qs('.sp-up__h', card);
    if (!hit) return;
    if (choose) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = choose.className;
      b.setAttribute('data-up-add', '');
      b.setAttribute('data-up-variant', hit.v);
      b.textContent = fill(choose.getAttribute('data-l-add') || 'Add {price}', { price: money(hit.p, true) });
      choose.replaceWith(b);
    }
    card.setAttribute('data-up-variant', hit.v);
    card.setAttribute('data-up-price', hit.p);
    if (h && h.getAttribute('data-up-heading-bike')) h.textContent = fill(h.getAttribute('data-up-heading-bike'), { bike: g.label(bike) });
    var row = qs('.sp-up__t', card);
    if (row && !qs('[data-up-vtitle]', row)) { var s = document.createElement('small'); s.setAttribute('data-up-vtitle', ''); s.textContent = hit.t; row.appendChild(s); }
  }
  /* One stack per surface: the drawer (or /cart) stack lives in root; a PDP stack is mounted by SP.Upsell.mount. */
  function stackSurface(stack) { return (stack && stack.getAttribute('data-surface')) || SURFACE; }
  function cards(stackEl) {
    var stack = stackEl || qs('[data-up-stack]');
    var inDrawer = !stackEl;
    if (inDrawer) current = null;
    if (!stack) return null;
    if (isDealer()) { stack.hidden = true; return null; }
    var skips = ssList('sp_cd_skip');
    var g = garage();
    var bike = g ? g.active() : null;
    /* The A4 bracket waits for the header answer: drawer lines answered, or the saved bike says Stealth headers. */
    var openQuestion = inDrawer
      ? qsa('[data-cd-kit]').some(function (k) { var l = k.closest('[data-cd-line]'); return !(l && l.classList.contains('is-hdr-ok')); })
      : bikeHeaders() !== 'stealth';
    var first = null;
    qsa('[data-up-card]', stack).forEach(function (card) {
      var ok = skips.indexOf(card.getAttribute('data-up-rule')) < 0;
      var model = card.getAttribute('data-up-model');
      if (ok && model) {
        var mode = 'ask';
        if (bike && bike.genId === 'softail-m8') {
          if (bike.model === model) mode = 'sell';
          else if (bike.model) ok = false;
        }
        cardMode(card, mode);
      }
      if (ok && card.getAttribute('data-up-after') === 'header answer' && openQuestion) ok = false;
      if (ok && card.hasAttribute('data-up-bikes') && g) applyBike(card, g, bike);
      card.hidden = true;
      if (ok && !first) first = card;
    });
    if (first) { first.hidden = false; promoView(first, stackSurface(stack)); }
    if (inDrawer) current = first;
    return first;
  }
  function promoView(card, surface) {
    surface = surface || SURFACE;
    if (!card || (surface === 'drawer' && !isOpen)) return;
    var rule = card.getAttribute('data-up-rule');
    if (seenPromo[surface + rule]) return;
    seenPromo[surface + rule] = 1;
    emit('sp:upsell:view', { rule: rule, surface: surface, handle: card.getAttribute('data-up-handle') });
  }

  function addFromCard(btn) {
    var card = btn.closest('[data-up-card]');
    if (!card || btn.getAttribute('aria-busy') === 'true') return;
    var stack = card.closest('[data-up-stack]');
    var surface = stackSurface(stack);
    var vid = parseInt(btn.getAttribute('data-up-variant') || card.getAttribute('data-up-variant') || '0', 10);
    if (!vid) return;
    var rule = card.getAttribute('data-up-rule');
    var g = garage(), bike = g ? g.active() : null;
    var asked = card.__mode === 'ask';
    /* "Yes, add it" on the Low Rider ST question saves the model (agreed API with sp2-knownfit). */
    if (asked && bike && bike.genId === 'softail-m8' && typeof g.setModel === 'function') { try { g.setModel(bike.id, card.getAttribute('data-up-model')); } catch (e) { /* ignore */ } }
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-disabled', 'true'); /* CR-03: not disabled, so focus stays on the button while it works */
    var label = btn.innerHTML;
    btn.textContent = 'Adding…';
    var before = snapshot();
    var entry = (card.getAttribute('data-up-src') || rule) + (asked ? '-ask' : '') + '@' + surface;
    var c = content();
    var prior = String((c && c.getAttribute('data-upsell-src')) || '').split(',').concat(ssList('sp_cd_src')).filter(Boolean);
    if (prior.indexOf(entry) < 0) prior.push(entry);
    var merged = prior.filter(function (x, i) { return prior.indexOf(x) === i; }).join(',');
    var title = card.getAttribute('data-up-title') || '';
    lastEventAt = Date.now();
    post('/cart/add.js', { items: [{ id: vid, quantity: 1 }] }, false).then(function () {
      ssAdd('sp_cd_src', entry);
      var kp = { Handle: card.getAttribute('data-up-handle'), VariantId: vid, Rule: rule, Surface: surface };
      /* BN26 (plan 4.3): shield adds in the promo report it */
      var pct = parseInt(card.getAttribute('data-up-pct') || '0', 10);
      if (pct && promoOn()) {
        var listP = parseInt(card.getAttribute('data-up-price') || '0', 10) || 0;
        var vt = qs('[data-up-vtitle]', card);
        kp.Promo = 'bn26'; kp.PromoPrice = Math.round(listP * (100 - pct) / 100);
        publish('bn26_shield_upsell_add', { variant_id: vid, finish: finishKey(vt ? vt.textContent : ''), surface: surface, list_price: listP, promo_price: kp.PromoPrice });
      }
      klaviyo('Added Cart Add-on', kp);
      emit('sp:upsell:add', { rule: rule, surface: surface, variant: vid });
      return post('/cart/update.js', { attributes: { cart_upsell_src: merged } });
    }).then(function (j) {
      /* A PDP card hands the result to the drawer and steps aside: the item is in the cart, not on offer. */
      if (stack && surface !== SURFACE) { card.hidden = true; ssAdd('sp_cd_skip', rule); cards(stack); if (IS_DRAWER) open(); }
      render(j && j.sections && j.sections[SECTION], { before: before, top: true, status: title + ' added.', focus: '[data-variant="' + vid + '"] .sp-cd__name' });
    }).catch(function (err) {
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('aria-disabled');
      btn.innerHTML = label;
      var e = qs('.sp-up__err', card);
      if (!e) { e = document.createElement('p'); e.className = 'sp-up__err'; e.setAttribute('role', 'alert'); card.appendChild(e); }
      e.textContent = err.message;
      refresh();
    });
  }
  function skipCard(btn) {
    var card = btn.closest('[data-up-card]');
    if (!card) return;
    var stack = card.closest('[data-up-stack]');
    var inDrawer = !!(stack && root.contains(stack));
    var rule = card.getAttribute('data-up-rule');
    if (btn.hasAttribute('data-up-ask-no')) {
      var g = garage(), bike = g ? g.active() : null;
      if (bike && bike.genId === 'softail-m8' && typeof g.setModel === 'function') { try { g.setModel(bike.id, 'other'); } catch (e) { /* ignore */ } }
    }
    ssAdd('sp_cd_skip', rule);
    emit('sp:upsell:skip', { rule: rule, surface: stackSurface(stack) });
    var next = cards(inDrawer ? null : stack);
    var target = next ? qs('.sp-up__h:not([hidden])', next) || qs('.sp-up__h', next) : (inDrawer ? qs('[data-cd-checkout]') : null);
    if (target) { if (!/^(BUTTON|A|INPUT)$/.test(target.tagName)) target.setAttribute('tabindex', '-1'); target.focus(); }
  }

  /* PDP companion card (sp2-pdp, item 10): {% render 'sp-upsell-brain', anchor: product, surface: 'pdp', exclude: 'A1' %}
     then SP.Upsell.mount(el). The heat shield variant follows the finish the rider picks on the page. */
  function finishKey(v) { v = String(v || '').toLowerCase(); return /polish/.test(v) ? 'polished' : (/black|cerakote/.test(v) ? 'black' : 'raw'); }
  function followFinish(stack, value) {
    qsa('[data-up-card][data-up-finishes]', stack).forEach(function (card) {
      var map = {};
      try { map = JSON.parse(card.getAttribute('data-up-finishes') || '{}'); } catch (e) { map = {}; }
      var hit = map[finishKey(value)];
      if (!hit) return;
      card.setAttribute('data-up-variant', hit.v);
      card.setAttribute('data-up-price', hit.p);
      var b = qs('[data-up-add]', card);
      if (b) {
        var tpl = b.getAttribute('data-l-sell') || '';
        b.setAttribute('data-l-sell', tpl.replace(/\$[\d,.]+/, hit.m));
        /* BN26: both labels and the struck price follow the finish */
        var pct = parseInt(card.getAttribute('data-up-pct') || '0', 10);
        if (pct) {
          var pm = money(Math.round(hit.p * (100 - pct) / 100), true);
          b.setAttribute('data-l-promo', (b.getAttribute('data-l-promo') || tpl).replace(/\$[\d,.]+/, pm));
          var ps = qs('[data-up-pricestate]', card); if (ps) ps.innerHTML = '<s><span class="visually-hidden">was </span>' + esc(hit.m) + '</s> <span class="visually-hidden">now </span>' + esc(pm);
        }
        if (card.__mode !== 'ask') b.innerHTML = pct ? '<span data-sp-promo-off>' + esc(b.getAttribute('data-l-sell')) + '</span><span data-sp-promo>' + esc(b.getAttribute('data-l-promo')) + '</span>' : esc(b.getAttribute('data-l-sell'));
      }
      var id = qs('[data-up-id]', card); if (id) id.value = hit.v;
      var vt = qs('[data-up-vtitle]', card); if (vt) vt.textContent = hit.t;
      var m = qs('.sp-up__match', card); if (m) m.hidden = true;
    });
  }
  function mount(el, opts) {
    var stack = el && (el.matches && el.matches('[data-up-stack]') ? el : el.querySelector('[data-up-stack]'));
    if (!stack || stack.__spMounted) return null;
    stack.__spMounted = true;
    if (opts && opts.surface) stack.setAttribute('data-surface', opts.surface);
    stack.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-up-add]'))) { e.preventDefault(); addFromCard(b); return; }
      if ((b = e.target.closest('[data-up-skip]'))) { e.preventDefault(); skipCard(b); }
    });
    var section = stack.closest('[data-section-type="product"]') || document;
    section.addEventListener('variantChange', function (e) {
      var v = e && e.detail && e.detail.variant;
      if (v && v.option1) followFinish(stack, v.option1);
    });
    var g = garage();
    if (g && typeof g.onChange === 'function') g.onChange(function () { cards(stack); });
    return cards(stack);
  }
  SP.Upsell = { mount: mount };

  /* ------------------------------------------------ Black November (BN26): one free Reverse Cone per system unit.
     After every render: systems and no gift: add (unless the rider removed it or it sold out); gift qty off: one change;
     no system: remove it. Qualifying = handle in SP_PROMO.systems. Dealers and the closed window: nothing. */
  var giftBusy = false, giftTries = 0, giftRetryAt = 0, giftOos = false;
  function promoOn() { var P = window.SP_PROMO; return !!(P && P.variant && document.documentElement.classList.contains('is-promo')) && !isDealer(); }
  function riderRemoved() { return ssList('sp_cd_gift_off').indexOf(cookie('cart') || 'x') > -1; }
  function giftState() {
    var cart = cartJson(), P = window.SP_PROMO || {}, systems = P.systems || [], sys = 0, gifts = [];
    if (!cart) return null;
    (cart.items || []).forEach(function (i) {
      if (i.properties && i.properties._bn26_gift) gifts.push(i);
      else if (i.product_type === 'Full Exhaust Systems' && systems.indexOf(i.handle) > -1) sys += i.quantity;
    });
    return { sys: sys, gifts: gifts, giftQty: gifts.reduce(function (n, i) { return n + i.quantity; }, 0) };
  }
  function giftRow(show, msg) {
    var r = qs('[data-cd-gift-restore]');
    if (!r) return;
    r.hidden = !show;
    var e = qs('[data-cd-gift-err]', r);
    if (e) { e.textContent = msg || ''; e.hidden = !msg; }
    var b = qs('[data-cd-gift-add]', r);
    if (b) { b.removeAttribute('aria-busy'); b.removeAttribute('aria-disabled'); }
  }
  function giftChange(key, qty) {
    giftBusy = true;
    post('/cart/change.js', { id: key, quantity: qty }).then(function (j) {
      giftBusy = false;
      render(j.sections && j.sections[SECTION]);
    }).catch(function () { giftBusy = false; refresh(); });
  }
  function reconcileGift() {
    if (giftBusy || !promoOn()) return;
    var s = giftState();
    if (!s) return;
    if (s.sys === 0) {
      if (s.giftQty > 0) giftChange(s.gifts[0].key, 0);
      else try { ssDel('sp_cd_gift_off', cookie('cart') || 'x'); } catch (e) { /* ignore */ }
      return;
    }
    if (s.giftQty === 0) {
      if (riderRemoved()) { giftRow(true); return; }
      if (giftOos) { giftRow(true, window.SP_PROMO.copy.oos); return; }
      if (Date.now() < giftRetryAt) { giftRow(true); return; }
      addFree(s.sys, SURFACE, 'auto');
      return;
    }
    giftRow(false);
    try { ssDel('sp_cd_gift_off', cookie('cart') || 'x'); } catch (e) { /* ignore */ }
    if (s.gifts.length === 1 && s.giftQty !== s.sys) giftChange(s.gifts[0].key, s.sys);
  }
  function addFree(qty, surface, how) {
    var P = window.SP_PROMO;
    if (!P || !P.variant || giftBusy) return;
    giftBusy = true;
    var before = snapshot();
    var props = {};
    props[P.giftKey || 'Gift'] = P.giftValue || 'Free with your full system';
    props._bn26_gift = '1';
    var entry = 'bn26-free@' + surface;
    var c = content();
    var prior = String((c && c.getAttribute('data-upsell-src')) || '').split(',').concat(ssList('sp_cd_src')).filter(Boolean);
    if (prior.indexOf(entry) < 0) prior.push(entry);
    var merged = prior.filter(function (x, i) { return prior.indexOf(x) === i; }).join(',');
    var firstSys = ((cartJson() || {}).items || []).filter(function (x) { return x.product_type === 'Full Exhaust Systems'; })[0];
    var handle = firstSys ? firstSys.handle : '';
    lastEventAt = Date.now();
    post('/cart/add.js', { items: [{ id: parseInt(P.variant, 10), quantity: Math.max(1, qty || 1), properties: props }] }, false).then(function () {
      giftTries = 0; giftRetryAt = 0;
      ssAdd('sp_cd_src', entry);
      try { ssDel('sp_cd_gift_off', cookie('cart') || 'x'); } catch (e) { /* ignore */ }
      giftTrack('ok', handle, surface, how);
      return post('/cart/update.js', { attributes: { cart_upsell_src: merged } });
    }).then(function (j) {
      giftBusy = false;
      render(j && j.sections && j.sections[SECTION], { before: before, status: P.copy.live, focus: how === 'manual' ? '[data-cd-gift] .sp-cd__name' : null });
      announce(P.copy.live);
    }).catch(function (err) {
      giftBusy = false;
      var oos = err && (err.status === 422 || /stock|sold out|available/i.test(err.message || ''));
      if (oos) { giftOos = true; giftTrack('oos', handle, surface, how); }
      else { giftTries += 1; giftRetryAt = Date.now() + Math.min(2000 * Math.pow(2, giftTries - 1), 30000); }
      refresh().then(function () { giftRow(true, oos ? P.copy.oos : (giftTries >= 3 || how === 'manual' ? err.message : '')); });
    });
  }
  /* BN26 analytics (plan 4.3): bn26_free_rc_added, Klaviyo "Added Free Reverse Cone", cart_upsell_src bn26-free@surface */
  function giftTrack(result, systemHandle, surface, how) {
    var P = window.SP_PROMO || {};
    var data = { system_handle: systemHandle || '', variant_id: P.variant || '', result: result, surface: surface, how: how || 'auto' };
    publish('bn26_free_rc_added', data);
    if (result === 'ok') klaviyo('Added Free Reverse Cone', { VariantId: P.variant, SystemHandle: systemHandle || '', Surface: surface });
    emit('sp:promo:free-added', data);
  }
  document.addEventListener('sp:promo', function () { reconcileGift(); });

  /* ---------------------------------------------------------------- quantity, remove, note */
  var qtyTimers = {};
  function setQty(line, q) {
    var key = line.getAttribute('data-key');
    var old = parseInt(line.getAttribute('data-qty') || '0', 10) || 0;
    q = Math.max(0, parseInt(q, 10) || 0);
    var input = qs('[data-cd-qty]', line);
    if (input) input.value = q;
    var minus = qs('[data-cd-step="-1"]', line);
    if (minus && q <= 1 && document.activeElement === minus && input) input.focus(); /* CR-03: disabling a focused button drops focus */
    if (minus) minus.disabled = q <= 1;
    line.classList.add('is-busy');
    line.setAttribute('aria-busy', 'true');
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      var before = snapshot();
      var gone = q === 0 ? ((cartJson() || { items: [] }).items.filter(function (i) { return i.key === key; })[0] || null) : null;
      /* BN26: a rider removal of the gift sticks until Undo or the restore row */
      if (q === 0 && line.hasAttribute('data-cd-gift')) ssAdd('sp_cd_gift_off', cookie('cart') || 'x');
      post('/cart/change.js', { id: key, quantity: q }).then(function (j) {
        render(j.sections && j.sections[SECTION], { before: q > old ? before : null });
        if (q === 0) { announce(line.getAttribute('data-name') + ' removed. Subtotal ' + money(subtotal()) + '.'); offerUndo(gone, line.getAttribute('data-name')); }
        else if (q < old) announce('Cart updated. Subtotal ' + money(subtotal()) + '.');
      }).catch(function (err) {
        refresh().then(function () {
          var nl = qs('[data-key="' + key + '"]');
          var e = nl ? qs('[data-cd-err]', nl) : null;
          if (e) { e.innerHTML = ICON_WARN + '<span>' + esc(err.message) + '</span>'; e.hidden = false; }
        });
      });
    }, 300);
  }
  /* CR-10: Remove is one tap, so it can be undone for 8 s: the same variant, quantity and properties (a Custom
     Badge line keeps its artwork link). The drawer cart JSON carries the properties. */
  var undoTimer;
  var undoActive = null; /* the open Undo row, so a later re-render (a background refresh) can put it back */
  function offerUndo(item, name, ms) {
    if (!item || !item.variant_id) return;
    var st = qs('[data-cd-status]');
    if (!st) { var b = qs('.sp-cd__body'); if (!b) return; st = document.createElement('p'); st.className = 'sp-cd__status'; st.setAttribute('role', 'status'); st.setAttribute('data-cd-status', ''); b.insertBefore(st, b.firstChild); }
    st.innerHTML = '<span>' + esc(name || 'Item') + ' removed.</span> <button type="button" class="sp-cd__link" data-cd-undo>Undo</button>';
    st.hidden = false;
    var props = {};
    Object.keys(item.properties || {}).forEach(function (k) { if (item.properties[k] !== null && item.properties[k] !== '') props[k] = item.properties[k]; });
    var ub = qs('[data-cd-undo]', st);
    ub.addEventListener('click', function onUndo(e) {
      e.preventDefault();
      /* CR-24: one restore per removal. A double tap once added the line twice (two /cart/add.js 200s). */
      if (st.__undoBusy) return;
      st.__undoBusy = true;
      undoActive = null;
      ub.setAttribute('aria-disabled', 'true'); ub.setAttribute('aria-busy', 'true'); ub.textContent = 'Restoring…';
      clearTimeout(undoTimer);
      var it = { id: item.variant_id, quantity: item.quantity || 1 };
      if (Object.keys(props).length) it.properties = props;
      post('/cart/add.js', { items: [it] }).then(function (j) {
        render(j.sections && j.sections[SECTION], { status: (name || 'Item') + ' is back in your cart.', focus: '[data-variant="' + item.variant_id + '"] .sp-cd__name' });
      }).catch(function (err) {
        st.__undoBusy = false;
        ub.removeAttribute('aria-disabled'); ub.removeAttribute('aria-busy'); ub.textContent = 'Undo';
        var m = st.querySelector('[data-cd-undo-err]');
        if (!m) { m = document.createElement('span'); m.setAttribute('data-cd-undo-err', ''); st.appendChild(m); }
        m.textContent = ' ' + err.message;
      });
    });
    /* D15 (WCAG 2.2.1 / 2.4.3): the 8 s window pauses while the row is hovered or focused, and when it closes with focus
       inside, focus moves to the first line's name or the cart heading instead of falling to <body>. */
    var left = ms || 8000, started = 0;
    var hide = function () {
      if (undoActive && undoActive.st === st) undoActive = null; /* R2-B1: also when the row is already gone or replaced */
      if (!st || !st.isConnected || !qs('[data-cd-undo]', st)) return;
      var hadFocus = st.contains(document.activeElement);
      st.hidden = true;
      if (hadFocus) {
        var t = qs('[data-cd-line] .sp-cd__name') || qs('#sp-cd-title') || qs('.sp-cd__page-title');
        if (t) { if (!t.matches('a, button, input') && !t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1'); t.focus(); }
      }
    };
    var run = function () { clearTimeout(undoTimer); started = Date.now(); undoTimer = setTimeout(hide, left); };
    var pause = function () { if (!started) return; clearTimeout(undoTimer); left = Math.max(1500, left - (Date.now() - started)); started = 0; };
    var resume = function () { if (st.matches(':hover') || st.contains(document.activeElement)) return; run(); };
    st.addEventListener('mouseenter', pause); st.addEventListener('focusin', pause);
    st.addEventListener('mouseleave', resume); st.addEventListener('focusout', function () { setTimeout(resume, 0); });
    undoActive = { item: item, name: name, st: st, remaining: function () { return started ? Math.max(1500, left - (Date.now() - started)) : left; } };
    run();
  }
  function toggleNote(force) {
    var t = qs('[data-cd-note-toggle]');
    if (!t) return;
    var box = document.getElementById(t.getAttribute('aria-controls'));
    var open = typeof force === 'boolean' ? force : t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (box) box.hidden = !open;
    if (open && force !== true) { var ta = qs('[data-cd-note]'); if (ta) ta.focus(); }
  }

  /* ---------------------------------------------------------------- empty state */
  function emptyBtn() {
    var b = qs('[data-cd-empty-btn]');
    if (!b) return;
    var g = garage(), bike = g ? g.active() : null;
    if (bike && typeof g.shopUrl === 'function') {
      b.removeAttribute('data-sp-garage-open');
      b.setAttribute('href', g.shopUrl(bike));
      b.textContent = fill(b.getAttribute('data-l-bike'), { bike: g.label(bike) });
    }
  }

  /* ---------------------------------------------------------------- open / close */
  var savedOverflow = '';
  function lockPage(on) {
    var h = document.documentElement;
    var page = document.getElementById('PageContainer');
    if (on) {
      var gap = window.innerWidth - h.clientWidth;
      savedOverflow = h.style.overflow;
      h.style.overflow = 'hidden';
      if (gap > 0) document.body.style.paddingRight = gap + 'px';
      if (page) page.inert = true;
    } else {
      h.style.overflow = savedOverflow;
      document.body.style.paddingRight = '';
      if (page) page.inert = false;
    }
  }
  function focusables() {
    return qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return !el.hasAttribute('data-cd-sentinel') && (el.offsetParent !== null || el === document.activeElement); });
  }
  /* Wallet buttons live in shadow roots and iframes, so a last-element check cannot see them. Two sentinels at the
     ends of the panel catch Tab and Shift+Tab whatever had focus before them. */
  if (panel) panel.addEventListener('focusin', function (e) {
    var s = e.target.getAttribute && e.target.getAttribute('data-cd-sentinel');
    if (!s || !isOpen) return;
    var f = focusables();
    if (!f.length) { focusFirst(); return; }
    (s === 'end' ? f[0] : f[f.length - 1]).focus();
  });
  function focusFirst() { var c = qs('.sp-cd__close'); if (c) c.focus(); else if (panel) panel.focus(); }
  /* The drawer sheet loads without blocking first paint (layout/theme.liquid, hub-perf). A tap before it lands waits for
     it, so the drawer never opens unstyled. */
  function cssReady(then) {
    var l = document.querySelector('link[data-sp-cd-css]');
    if (!l || l.media === 'all') return true;
    var done = false;
    function go() { if (done) return; done = true; l.media = 'all'; then(); }
    l.addEventListener('load', go, { once: true });
    l.media = 'all';
    setTimeout(go, 1500);
    return false;
  }
  function open(opts) {
    opts = opts || {};
    if (!IS_DRAWER) { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    if (!isOpen && !cssReady(function () { open(opts); })) return;
    var was = isOpen;
    if (!isOpen) {
      lastTrigger = opts.trigger || document.activeElement;
      root.hidden = false;
      void root.offsetWidth;
      root.classList.add('is-open');
      document.body.classList.add('sp-cd-open');
      lockPage(true);
      isOpen = true;
      seenPromo = {};
      setTimeout(focusFirst, 40);
      emit('sp:cart:open', { surface: SURFACE });
    }
    if (opts.skeleton && !was) addSkeleton();
    if (current) promoView(current);
  }
  function close(opts) {
    opts = opts || {};
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    document.body.classList.remove('sp-cd-open');
    lockPage(false);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () { if (!isOpen) root.hidden = true; }, reduce ? 0 : 220);
    if (opts.restore !== false && lastTrigger && typeof lastTrigger.focus === 'function' && document.contains(lastTrigger)) lastTrigger.focus();
    emit('sp:cart:close', { surface: SURFACE });
  }
  function addSkeleton() {
    if (qs('.sp-cd__skel')) return;
    var list = qs('[data-cd-lines]');
    var li = document.createElement('li');
    li.className = 'sp-cd__skel';
    li.setAttribute('aria-hidden', 'true');
    li.innerHTML = '<i class="img"></i><i style="width:85%"></i><i style="width:45%"></i><i style="width:60%"></i>';
    if (list) list.insertBefore(li, list.firstChild);
    else { var b = qs('.sp-cd__body'); if (b) b.insertBefore(li, b.firstChild); }
    setTimeout(function () { if (li.parentNode) li.parentNode.removeChild(li); }, 6000);
  }

  /* ---------------------------------------------------------------- offline */
  function applyOffline() {
    var off = navigator.onLine === false;
    root.classList.toggle('is-offline', off);
    var banner = qs('[data-cd-offline]');
    if (banner) banner.hidden = !off;
    qsa('[data-cd-step], [data-up-add], [data-cd-qty], [data-cd-hdr-ok], [data-sp-kit-swap], [data-sp-kit-add], [data-cd-gift-add]').forEach(function (el) {
      if (off) { if (!el.disabled) { el.setAttribute('data-cd-off', '1'); el.disabled = true; } }
      else if (el.getAttribute('data-cd-off')) { el.removeAttribute('data-cd-off'); el.disabled = false; }
    });
    var co = qs('[data-cd-checkout]');
    if (co) co.setAttribute('aria-disabled', off ? 'true' : 'false');
  }
  window.addEventListener('online', function () { applyOffline(); refresh(); });
  window.addEventListener('offline', applyOffline);

  /* ---------------------------------------------------------------- events inside the cart */
  root.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = t.closest('[data-cd-close]'))) { e.preventDefault(); close(); return; }
    if ((el = t.closest('[data-cd-step]'))) {
      var line = el.closest('[data-cd-line]');
      if (line) setQty(line, (parseInt((qs('[data-cd-qty]', line) || {}).value || line.getAttribute('data-qty'), 10) || 0) + parseInt(el.getAttribute('data-cd-step'), 10));
      return;
    }
    if ((el = t.closest('[data-cd-remove]'))) { e.preventDefault(); if (root.classList.contains('is-offline')) return; var rl = el.closest('[data-cd-line]'); if (rl) setQty(rl, 0); return; }
    if ((el = t.closest('[data-cd-gift-add]'))) {
      e.preventDefault();
      if (root.classList.contains('is-offline') || el.getAttribute('aria-busy') === 'true') return;
      el.setAttribute('aria-busy', 'true'); el.setAttribute('aria-disabled', 'true');
      try { ssDel('sp_cd_gift_off', cookie('cart') || 'x'); } catch (e2) { /* ignore */ }
      giftOos = false; giftTries = 0; giftRetryAt = 0;
      var gs = giftState();
      addFree(gs ? Math.max(1, gs.sys) : 1, SURFACE, 'manual');
      return;
    }
    if ((el = t.closest('[data-up-add]'))) { e.preventDefault(); addFromCard(el); return; }
    if ((el = t.closest('[data-up-skip]'))) { e.preventDefault(); skipCard(el); return; }
    if ((el = t.closest('[data-cd-note-toggle]'))) { e.preventDefault(); toggleNote(); return; }
    if ((el = t.closest('[data-cd-hdr-ok]'))) {
      e.preventDefault();
      var hl = el.closest('[data-cd-line]');
      if (hl) {
        ssAdd('sp_cd_hdr', hl.getAttribute('data-key'));
        var gh = garage(), bh = gh ? gh.active() : null;
        if (bh && typeof gh.setHeaders === 'function') { try { gh.setHeaders(bh.id, 'stealth'); } catch (err) { /* ignore */ } }
        headerQuestion(); cards(); var u = qs('[data-cd-hdr-undo]', hl); if (u) u.focus();
      }
      return;
    }
    if ((el = t.closest('[data-cd-hdr-undo]'))) {
      e.preventDefault();
      var ul = el.closest('[data-cd-line]');
      if (ul) {
        var gu = garage(), bu = gu ? gu.active() : null;
        /* D11: with a saved bike the answer belongs to the bike, so Undo clears it for every line (session keys too);
           without a bike each line keeps its own answer. */
        if (bu) { try { sessionStorage.removeItem('sp_cd_hdr'); } catch (err) { /* ignore */ } }
        else ssDel('sp_cd_hdr', ul.getAttribute('data-key'));
        if (bu && bu.headers && typeof gu.setHeaders === 'function') { try { gu.setHeaders(bu.id, null); } catch (err) { /* ignore */ } }
        headerQuestion(); cards(); var q = qs('[data-cd-hdr-ok]', ul); if (q) q.focus();
      }
      return;
    }
    if ((el = t.closest('[data-cd-checkout]'))) {
      if (el.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      emit('sp:cart:checkout', { surface: SURFACE, total: subtotal() });
      return; /* the form posts; Wholesale Gorilla reroutes dealers itself */
    }
    /* The My Bike sheet opens on top of the page, so the cart steps aside without taking focus back. */
    if (t.closest('[data-sp-garage-open]') && IS_DRAWER) {
      var gl = t.closest('[data-cd-line]');
      reopenFor = gl ? gl.getAttribute('data-key') : '';
      close({ restore: false });
    }
  });
  /* CR-20: My Bike opened from the cart hands the rider back to the cart (and the line) when it closes */
  var reopenFor = null;
  document.addEventListener('sp:garage-close', function () {
    if (reopenFor === null || !IS_DRAWER) return;
    var key = reopenFor; reopenFor = null;
    /* next tick: the Escape that closed My Bike would otherwise reach this drawer's own Escape handler and close it */
    setTimeout(function () { open(); }, 0);
    setTimeout(function () {
      var l = key ? qs('[data-key="' + key + '"]') : null;
      var f = l ? (qs('[data-sp-kit-swap], [data-cd-hdr-ok], .sp-cd__name', l)) : null;
      if (f) f.focus();
    }, 400);
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-cd-qty]')) { var line = t.closest('[data-cd-line]'); if (line) setQty(line, t.value); return; }
    if (t.matches('[data-cd-note]')) { post('/cart/update.js', { note: t.value }, false).catch(function () {}); }
  });
  root.addEventListener('keydown', function (e) {
    if (e.target.matches && e.target.matches('[data-cd-qty]') && e.key === 'Enter') { e.preventDefault(); e.target.blur(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    if (!panel.contains(document.activeElement)) { var f = focusables(); if (f.length) { e.preventDefault(); f[0].focus(); } }
  });

  /* ---------------------------------------------------------------- add paths */
  /* Header cart icon(s): open the drawer instead of following the /cart link (the link stays for no-JS). */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.js-drawer-open-cart');
    if (!t || !IS_DRAWER) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (stale || Date.now() - lastRead > 60000) refresh();
    open({ trigger: t });
  }, true);

  /* Product forms post with Impulse's own multipart FormData (the Custom Badge file rides it). One hidden field makes
     that same response carry the drawer HTML, so the first open needs no second request. */
  function tagForms(scope) {
    if (!IS_DRAWER) return;
    ((scope || document).querySelectorAll ? (scope || document).querySelectorAll('form[action*="/cart/add"]') : []).forEach(function (f) {
      if (f.closest('[data-up-card]') || f.querySelector('input[name="sections"]')) return;
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'sections'; i.value = SECTION;
      f.appendChild(i);
    });
  }
  tagForms(document);
  if ('MutationObserver' in window) {
    var tagT = null;
    new MutationObserver(function () { clearTimeout(tagT); tagT = setTimeout(function () { tagForms(document); }, 150); })
      .observe(document.body, { childList: true, subtree: true });
  }

  /* Impulse AjaxProduct: success fires ajaxProduct:added on the form with detail.product; a 422 also fires one on
     document with no detail (assets/theme.js 2824), which must not open the cart. */
  document.addEventListener('ajaxProduct:added', function (e) {
    var d = e && e.detail;
    if (!d || !d.product) return;
    lastEventAt = Date.now();
    /* BN26 (plan 4.3): a Custom Badge add in the promo reports the price shown */
    try {
      if (promoOn() && /custom/i.test(String(d.product.variant_title || ''))) {
        var B = (window.SP_PROMO && SP_PROMO.badge) || { surcharge: 0, off: 0 };
        var bd = { product_handle: d.product.handle || '', variant_id: d.product.variant_id || d.product.id || '', badge_price_shown: B.surcharge - B.off, surcharge: B.surcharge, promo_off: B.off };
        publish('bn26_badge_added', bd);
        klaviyo('Added Custom Badge', { ProductHandle: bd.product_handle, VariantId: bd.variant_id, BadgePriceShown: bd.badge_price_shown, Promo: 'bn26' });
      }
    } catch (e2) { /* analytics never blocks the add */ }
    var before = snapshot();
    var html = d.product.sections && d.product.sections[SECTION];
    if (IS_DRAWER) open({ skeleton: !html });
    if (html) render(html, { before: before, top: true });
    else refresh({ before: before, top: true });
  });
  /* Other surfaces that already hold the section HTML (the PDP bracket row, sp2-pdp) hand it over:
     detail { sections, src }. src, when given, is appended to cart_upsell_src with one /cart/update.js that also
     returns the section. */
  document.addEventListener('sp:cart:render', function (e) {
    var d = (e && e.detail) || {};
    lastEventAt = Date.now();
    var before = snapshot();
    var finish = function (html) { if (IS_DRAWER) open(); if (html) render(html, { before: before, top: true }); else refresh({ before: before, top: true }); };
    if (d.src) {
      var c = content();
      var prior = String((c && c.getAttribute('data-upsell-src')) || '').split(',').concat(ssList('sp_cd_src')).filter(Boolean);
      if (prior.indexOf(d.src) < 0) prior.push(d.src);
      ssAdd('sp_cd_src', d.src);
      post('/cart/update.js', { attributes: { cart_upsell_src: prior.filter(function (x, i) { return prior.indexOf(x) === i; }).join(',') } })
        .then(function (j) { finish(j && j.sections && j.sections[SECTION]); })
        .catch(function () { finish(d.sections && d.sections[SECTION]); });
    } else finish(d.sections && d.sections[SECTION]);
  });

  /* V2 add paths (kit builder, cart swap, old add-on buttons) fire cart:build then cart:open. */
  var buildBefore = null;
  document.addEventListener('cart:build', function () {
    lastEventAt = Date.now();
    buildBefore = snapshot();
    refresh({ before: buildBefore, top: true });
  });
  document.addEventListener('cart:open', function () { lastEventAt = Date.now(); open({ skeleton: false }); });

  /* Anything else that changes the cart (apps, the Shop app, Wholesale Gorilla's quick order form). */
  if ('PerformanceObserver' in window) {
    try {
      var extT = null, extAdd = false;
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) {
          var m = /\/cart\/(add|change|clear)(\.js)?(\?|$)/.exec(en.name);
          if (!m || Date.now() < selfUntil) return;
          if (m[1] === 'add') extAdd = true;
          clearTimeout(extT);
          extT = setTimeout(function () {
            /* An Impulse or V2 add announces itself a moment later; let that path handle it. */
            if (Date.now() - lastEventAt < 1500) { extAdd = false; return; }
            var before = snapshot();
            if (extAdd && IS_DRAWER) open({ skeleton: true });
            refresh({ before: before, top: extAdd });
            extAdd = false;
          }, 450);
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* older browsers: the events above still cover every theme path */ }
  }

  /* Another tab changed the cart: re-read once, now if this tab is in view, else on return. No polling. */
  function remoteChange() { if (document.visibilityState === 'visible' && (isOpen || !IS_DRAWER)) refresh(); else stale = true; }
  if (bc) bc.onmessage = remoteChange;
  window.addEventListener('storage', function (e) { if (e.key === 'sp_cart_ping') remoteChange(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && (stale || Date.now() - lastRead > 120000)) refresh();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  /* Saved bike changes (picker, model answer) re-run the bike-aware parts. */
  function onBike() { fitLines(); cards(); emptyBtn(); }
  (function whenGarage(tries) {
    var g = garage();
    if (g) { if (typeof g.onChange === 'function') g.onChange(onBike); onBike(); return; }
    if (tries < 25) setTimeout(function () { whenGarage(tries + 1); }, 200);
  })(0);
  document.addEventListener('sp:garage-change', onBike);

  /* /cart on phones: the sticky Check out bar shows only while the summary's own button is out of view. */
  var pageObs = null;
  function pageBar() {
    if (IS_DRAWER || !('IntersectionObserver' in window)) return;
    var bar = qs('[data-cd-pagebar]'), btn = qs('[data-cd-checkout]');
    if (pageObs) pageObs.disconnect();
    if (!bar || !btn) return;
    pageObs = new IntersectionObserver(function (en) {
      var show = !en[0].isIntersecting;
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.inert = !show;
      var b = qs('.cart__checkout', bar); if (b) b.tabIndex = show ? 0 : -1;
    });
    pageObs.observe(btn);
  }
  document.addEventListener('sp:cart:change', pageBar);

  document.body.classList.add('sp-cd-on');
  enhance();
  pageBar();
  var initCart = cartJson();
  if (initCart && initCart.item_count) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: initCart } }));
    emit('sp:cart:change', { count: initCart.item_count, total: initCart.total_price, cart: initCart });
  }

  SP.CartDrawer = {
    open: open,
    close: close,
    refresh: function (opts) {
      opts = opts || {};
      var before = snapshot();
      if (opts.open && IS_DRAWER) open({ skeleton: true });
      return refresh({ before: before, top: true });
    }
  };
})();
